<section class="flex justify-content-center mt-1">
  <div class="card-table col-12 flex flex-column">
    <div>
      <CustomTitle [title]="'components.app-rango-tiempo.title' | translate"
                   [styleClass]="'font-principal app-title-page-color font-medium font-18 text-uppercase mt-4 '"/>
    </div>
    <custom-table [config]="configTable"/>
  </div>
</section>

<p-dialog [(visible)]="openDialog" [closable]="true" appendTo="body"
          [header]="title()" draggable="false" [modal]="true" (onHide)="hideModal()"
          [breakpoints]="{'2000px': '60vw', '1900px': '60vw', '1700px': '60vw',
           '1400px': '75vw', '960px': '90vw', '640px': '95vw'}">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="card p-fluid grid ">
    <div class="field  col-12 md:col-6">
      <label for="diaInicio">{{ 'components.app-rango-tiempo.dia-inicial' | translate }}</label>
      <p-inputNumber id="diaInicio" formControlName="diaInicio"
                     mode="decimal" [min]="0"
                     placeholder="{{ 'components.app-rango-tiempo.placeholder-dia-inicial' | translate }}"></p-inputNumber>
      @if (form.get('diaInicio')?.invalid && form.get('diaInicio')?.touched) {
        <app-form-group-error-message [control]="form.get('diaInicio')"/>
      }
    </div>
    <div class="field  col-12 md:col-6">
      <label for="diaFinal">{{ 'components.app-rango-tiempo.dia-final' | translate }}</label>
      <p-inputNumber id="diaFinal" formControlName="diaFinal" mode="decimal" [min]="1"
                     placeholder="{{ 'components.app-rango-tiempo.placeholder-dia-final' | translate }}"
      ></p-inputNumber>

    </div>
    <div class="field  col-12 md:col-6">
      <label for="indicador">{{ 'components.app-rango-tiempo.indicador' | translate }}</label>
      <input pInputText id="indicador"
             placeholder="{{ 'components.app-rango-tiempo.placeholder-indicador' | translate }}"
             formControlName="indicador" >
      @if (form.get('indicador')?.invalid && form.get('indicador')?.touched) {
        <app-form-group-error-message [control]="form.get('indicador')"/>
      }
    </div>

    <div class="field  col-12 md:col-6">
      <label for="color">{{ 'components.app-rango-tiempo.color' | translate }}</label>
      <p-dropdown appendTo="body" styleClass="border-round-xl	"
                  placeholder="{{ 'components.app-rango-tiempo.placeholder-color' | translate }}"
                 formControlName="color" [options]="colors" optionValue="value">
        <ng-template pTemplate="selectedItem" let-selectItem>
          <div class="flex gap-2 align-items-center">
            <div class="dropdown__item" [style.background]="selectItem.value"></div>
            <p class="dropdown__text">{{selectItem.description | uppercase}}</p>
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-item>
          <div class="flex gap-2 align-items-center">
            <div class="dropdown__item" [style.background]="item.value"></div>
            <p class="dropdown__text">{{item.description | uppercase}}</p>
          </div>
        </ng-template>
      </p-dropdown>

    </div>

    <div class="col-12 justify-content-end">

      <button pButton class="md:w-12rem"
              type="submit" label="{{'form.button.guardar' | translate }}"
              [disabled]="form.invalid" icon="pi pi-check"></button>
    </div>

  </form>
</p-dialog>
